import { Button, Dialog, DialogContent, DialogActions, DialogTitle, FormControlLabel, Grid, IconButton, FormControl, Switch, Box, Popover, Typography } from "@mui/material";
import { AutocompleteElement, TextFieldElement, FormContainer } from "react-hook-form-mui"
import { Fragment, useState } from "react";
import { selectCurrentUser } from "../../../../redux/reducers/authSlice";
import { GridActionsCellItem, DataGrid, GridToolbar, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton, GridToolbarQuickFilter } from "@mui/x-data-grid"
import CloseIcon from "@mui/icons-material/Cancel"
import DoneIcon from "@mui/icons-material/Done"
import VisibilityIcon from '@mui/icons-material/Visibility';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AddIcon from "@mui/icons-material/Add"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import DeleteUsersModal from "../deletePersonasModal/DeletePersonasModal";
import theme from "../../../../theme";
import { useSelector, useDispatch } from 'react-redux';
const PersonasJuridicasTable = (props) => {
  const currentUser = useSelector(selectCurrentUser);

  const dispatch = useDispatch();
  const [showNuevaPersonaForm, setShowNuevaPersonaForm] = useState(false);
  const [errores, setErrores] = useState([])
  const openForm = () => setShowNuevaPersonaForm(true);
  const closeForm = () => setShowNuevaPersonaForm(false);
  const [confirmDeleteUsers, setConfirmDeleteUsers] = useState(null);

  let formDflts = { numeroInscripcionRegistral: '', rolesIds: [10], nombreFantasia: '', web: '', email: '', telefono1: '', cuit: '', pais: '', provincia: '', ciudad: '', apoderadoId: '', representanteId: '', referenciadoId: '', cbu: '', codigoPostal: '', calle: '', altura: '' };
  const [defaultValues, setDefaultValues] = useState({ ...formDflts });

  const NuevaPersonaJuridicaForm = () => {
    function handleSubmit(newPersona) {
      //Validacion CUIT
      // setDefaultValues(newPersona)
      // let tipoCuit = newPersona.cuit?.toString()?.slice(0, 2)
      // let errs = [];
      // setErrores([]);
      // let huboError = false;
      // if (
      //   (newPersona.cuit.toString().length !== 11) &&
      //   !(
      //     newPersona.cuit === undefined ||
      //     newPersona.cuit === ""
      //   )
      // ) {
      //   errs = [
      //     ...errs,
      //     'Debe ingresar un N° de CUIT de 11 digitos. El campo "CUIT" tiene ' +
      //     newPersona.cuit.toString().length +
      //     " digitos.",
      //   ];
      // }
      // if (!(['30', '33', '34', '20', '23', '24', '25', '26', '27'].includes(tipoCuit))) {
      //   errs = [
      //     ...errs,
      //     'Debe ingresar un N° de CUIT que comience con 30, 33, 34, 20, 23, 24, 25, 26 o 27.',
      //   ];
      // }
      // if (errs.length > 0) {
      //   huboError = true;
      // }
      // setErrores(errs);
      // if (huboError) return;

      let newPersonaAux = { ...newPersona };
      if (newPersonaAux.referenciadoId) newPersonaAux.referenciadoId = newPersonaAux.referenciadoId.id;
      let estamosEditando = defaultValues.personaId !== undefined;
      if (estamosEditando) {
        delete newPersonaAux.roles
        delete newPersonaAux.password
        dispatch(props.editPersona(newPersonaAux)).unwrap()
          .then((result) => {
            console.log('result', result);
          })
          .catch((error) => {
            console.log('error', error);
          });
      } else {
        newPersonaAux.activo = true;
        newPersonaAux.cuit = newPersonaAux.cuil;

        dispatch(props.addPersona(newPersonaAux)).unwrap()
          .then(res => console.log(res))
          .catch(err => console.log(err));
      }
      closeForm()
    };
    function setDefaults(auxPersona) {
      auxPersona.cuil = auxPersona.cuit;
      auxPersona.personaFisica = false;
      auxPersona.activo = true;
      auxPersona.apoderadoId = auxPersona.apoderadoId.id;
      auxPersona.representanteId = auxPersona.representanteId.id;
      auxPersona.referenciadoId = auxPersona.referenciadoId.id;
      return auxPersona;
    }


    return (
      <Dialog maxWidth='lg' fullWidth={false} onClose={closeForm} open={showNuevaPersonaForm}>
        <DialogTitle fontWeight={700} style={{ backgroundColor: theme.palette.success.main, color: 'white' }}>Nueva Persona Juridica:</DialogTitle>
        <FormContainer defaultValues={defaultValues} onSuccess={handleSubmit} >
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='Razón Social' name='numeroInscripcionRegistral' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='Nombre Fantasía' name='nombreFantasia' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='Web' name='web' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='Email' name='email' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='Teléfono' name='telefono1' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} label='CUIT/CUIL' required name='cuit' />
              </Grid>
              <Grid item xs={6}>
                <TextFieldElement sx={{ width: '100%' }} label='CBU' name='cbu' />
              </Grid>
              <Grid item xs={6}>
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='País' name='pais' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='Provincia' name='provincia' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} required label='Ciudad' name='ciudad' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} label='Calle' name='calle' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} type='number' label='Altura' name='altura' />
              </Grid>
              <Grid item xs={4}>
                <TextFieldElement sx={{ width: '100%' }} type='number' label='Codigo Postal' name='codigoPostal' />
              </Grid>
              <Grid item xs={6}>
                <AutocompleteElement
                  name='representanteId'
                  label='Representante'
                  options={props.getDropdownOptions()}
                  sx={{ width: '100%', padding: '10px' }}
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <AutocompleteElement
                  name='apoderadoId'
                  label='Apoderado'
                  options={props.getDropdownOptions()}
                  sx={{ width: '100%', padding: '10px' }}
                  required
                />

              </Grid>
              <Grid item xs={6}>
                <AutocompleteElement
                  name='referenciadoId'
                  label='Referido por'
                  options={props.getDropdownOptions()}
                  sx={{ width: '100%', padding: '10px' }}

                />
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ width: '100%' }} variant="outlined">
                  <TextFieldElement sx={{ width: '100%' }} label='URL Documentación' name='documentacion' />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ color: "error.main" }}>
                {errores.length > 0 &&
                  errores.map((error, i) => (
                    <p style={{ marginLeft: "8px" }} key={"errNuevoRegistro" + i}>
                      - {error}
                    </p>
                  ))}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={closeForm} sx={{ marginTop: '10px', fontWeight: "bold" }}>{"Cancelar"}</Button>
            <Button variant="contained" type={'submit'} sx={{ marginRight: '5px', marginTop: '10px', color: "white", fontWeight: "bold" }}>{"Aceptar"}</Button>
          </DialogActions>
        </FormContainer>
      </Dialog>
    )

  };

  function handleEdit(persona) {
    let user = props.personas.find(p => p.personaId === persona.personaId);
    let rolesForUser = (props.rolesMap.entities).filter(rolMap => rolMap.personaId === user.personaId);
    user.rolesIds = rolesForUser.map(rolMap => rolMap.rolId);
    if (user.representanteId) user.representanteId = { id: user.representanteId, label: props.getLabel(props.personas?.find(p=> p.personaId === user.representanteId)) };
    if (user.apoderadoId) user.apoderadoId = { id: user.apoderadoId, label: props.getLabel(props.personas?.find(p=> p.personaId === user.apoderadoId)) };
    if (user.referenciadoId) user.referenciadoId = { id: user.referenciadoId, label: props.getLabel(props.personas?.find(p=> p.personaId === user.referenciadoId)) };
    //A: los definimos asi para que el autocomplete los reconozca como valores default
    setDefaultValues(user);
    openForm();
  };
  const GridAction = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
      setAnchorEl(null);
    };
    const { label, key, Icon, color } = props;
    const open = Boolean(anchorEl);
    return (
      <Fragment key={key + label}>
        <Icon
          aria-owns={open ? label : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
          color={color}
        >
          {" "}
        </Icon>
        <Popover
          id={label}
          sx={{
            pointerEvents: "none",
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography sx={{ p: 1 }}>{label}</Typography>
        </Popover>
      </Fragment>
    );
  };

  const columns = [
    {
      field: 'estado', headerName: 'Estado', flex: 50, type: 'actions', renderCell: v =>
        <>
          <GridActionsCellItem key={v.row.personaId + '-darAltaPersonasHumanasGridAction'} disabled={currentUser.permisos.includes('altaPersona') ? false : true} onClick={() => props.setUserRegisterModal(v.row)} icon={
            <GridAction
              label={v.row.password === null ? 'Esperando Alta' : v.row.activo ? 'Dado de Alta' : 'Alta Eliminada'}
              key={'PersonasHumanas-' + v.row.personaId}
              Icon={v.row.password === null ? ScheduleIcon : v.row.activo ? DoneIcon : CloseIcon}
              color={currentUser.permisos.includes('altaPersona') ? v.row.password === null ? 'secondary' : v.row.activo ? 'primary' : 'danger' : 'secondary'}
            />}
          />
        </>
    },
    { field: 'personaId', headerName: 'ID', flex: 10 },
    { field: 'denominacionSocial', headerName: 'Denominación Social', flex: 110 },
    { field: 'email', headerName: 'Email', flex: 150 },
    { field: 'cuit', headerName: 'CUIT/CUIL', flex: 70, valueGetter: v => v.row.cuit ? v.row.cuit.toString() : v.row.cuit },
    { field: 'telefono1', headerName: 'Teléfono', flex: 80 },

    { field: 'pais', headerName: 'Pais', flex: 70 },
    { field: 'provincia', headerName: 'Provincia', flex: 80 },
    { field: 'ciudad', headerName: 'Ciudad', flex: 80 },
    {
      field: 'roles', headerName: 'Roles', flex: 50,
    },
    {
      field: 'actions', headerName: 'Acciones', flex: 100, type: 'actions', renderCell: v =>
        <>
          <GridActionsCellItem key={v.row.personaId + '-verDetallesPersonasHumanasGridAction'} onClick={() => props.setUserMoreDetail(v.row)} icon={<GridAction label={'Ver Detalles'} key={'PersonasHumanas-' + v.row.personaId} Icon={VisibilityIcon} color={'primary'} />} />
          <GridActionsCellItem key={v.row.personaId + '-editarPersonasHumanasGridAction'} disabled={props.isEditButtonDisabled(v.row.personaId)} color={'primary'} onClick={() => handleEdit(v.row)} icon={<GridAction label={'Editar'} key={'PersonasHumanas-' + v.row.personaId} Icon={EditIcon} color={props.isEditButtonDisabled(v.row.personaId) ? 'secondary' : 'info'} />} />
          <GridActionsCellItem key={v.row.personaId + '-borrarPersonasHumanasGridAction'} disabled={props.isDeleteButtonDisabled(v.row.personaId)} color={'primary'} onClick={() => setConfirmDeleteUsers(v.row)} icon={<GridAction label={'Eliminar'} key={'PersonasHumanas-' + v.row.personaId} Icon={DeleteIcon} color={props.isDeleteButtonDisabled(v.row.personaId) ? 'secondary' : 'danger'} />} />
          <GridActionsCellItem key={v.row.personaId + '-darAltaPersonasHumanasGridAction'} disabled={currentUser.permisos.includes('altaPersona') ? false : true} onClick={() => props.setUserRegisterModal(v.row)} icon={
            <GridAction
              label={v.row.password === null ? 'Esperando Alta' : v.row.activo ? 'Dado de Alta' : 'Alta Eliminada'}
              key={'PersonasHumanas-' + v.row.personaId}
              Icon={v.row.password === null ? ScheduleIcon : v.row.activo ? DoneIcon : CloseIcon}
              color={currentUser.permisos.includes('altaPersona') ? v.row.password === null ? 'secondary' : v.row.activo ? 'primary' : 'danger' : 'secondary'}
            />}
          />
        </>
    },
  ];
  const rows = (props.personas || []).filter(p => !p.personaFisica && !p.eliminado);

  const BtnBar = () => {

    return (
      <Fragment>
        
          <Fragment>
          <Button className="mb-3" variant="contained" color='primary' sx={{ height: '4vh', width: '15%', fontWeight: 'bold', margin: '0.4em' }}  onClick={openForm}>NUEVO<AddIcon /></Button>
            {/* <IconButton className="mb-3" variant="contained" color='primary' onClick={openForm}><AddIcon /></IconButton> */}
          </Fragment>
        <FormControlLabel control={<Switch onChange={props.handleSwitchChange} checked={props.showDeletedUsers} />} label="Mostrar Eliminados" />

      </Fragment>
    );
  };
  return (
    <Fragment>
      
      <DeleteUsersModal open={confirmDeleteUsers} user={confirmDeleteUsers} close={() => setConfirmDeleteUsers(null)} onConfirm={() => props.handleDelete(confirmDeleteUsers.personaId)} />
      <NuevaPersonaJuridicaForm />
      <Box sx={{ width: '100%' }}>
        <DataGrid
           pagination
           sx={{ height: '70vh', width: '100%' }}
          getRowId={r => r.personaId}
          rows={props.personas || []}
          columns={columns}
          pageSize={100}
          rowsPerPageOptions={[5]}
          experimentalFeatures={{ newEditingApi: true }}
          components={{
            Toolbar: () => {
              return <Fragment>
                <GridToolbarContainer>
                  <Grid conteiner
                    rowSpacing={0} sx={{
                      display: "inline-flex",
                      justifyContent: "space-between",
                      alignItems: "strech",
                      width: "100%"
                    }}>
                      {currentUser?.permisos?.includes("writePersonas") ? <BtnBar/> : null}
                    <Grid sx={{ width: "100%" }}>
                      <GridToolbarColumnsButton /><GridToolbarFilterButton /> <GridToolbarDensitySelector />
                      {currentUser?.permisos?.includes('export-data') ? <> <GridToolbarExport /> </>
                        : ''}
                    </Grid>
                    <GridToolbarQuickFilter />
                  </Grid>
                </GridToolbarContainer>
              </Fragment>
            }
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                //personaId: false,
                pais: false,
                provincia: false,
                cuit: false,
              },
            },
          }}
          loading={props.fetching > 1}
        />
      </Box>
    </Fragment>);
};

export default PersonasJuridicasTable;